export default {"src":"/_next/static/media/play-white-blue.d3318ab1.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};